import type NotificationSystem from "react-notification-system";

/** Width of legacy `wpb-popup` — keep redesign popups at the same footprint. */
export const PATIENT_ACTION_POPUP_WIDTH_PX = 567;

/**
 * Styles for popup notifications that render their full UI in `children`
 * (legacy `wpb-popup` / redesign patient-action card).
 *
 * The NotificationItem host must be invisible — only the child punches through
 * with `visibility: visible`. Dismiss × is also suppressed via `dismissible: false`
 * on those notifications.
 */
export const notificationCustomStyle = {
  Wrapper: {},
  Containers: {
    DefaultStyle: {
      width: PATIENT_ACTION_POPUP_WIDTH_PX,
      padding: 0,
    },
    tc: {
      top: "50%",
      bottom: "auto",
      left: "50%",
      marginLeft: -(PATIENT_ACTION_POPUP_WIDTH_PX / 2),
      transform: "translateY(-50%)",
      width: PATIENT_ACTION_POPUP_WIDTH_PX,
    },
  },
  Dismiss: {
    DefaultStyle: {
      display: "none",
      width: 0,
      height: 0,
      opacity: 0,
      pointerEvents: "none",
    },
    success: {
      display: "none",
      opacity: 0,
    },
  },
  NotificationItem: {
    DefaultStyle: {
      visibility: "hidden",
      backgroundColor: "transparent",
      border: "none",
      borderTop: "none",
      boxShadow: "none",
      WebkitBoxShadow: "none",
      MozBoxShadow: "none",
      padding: 0,
      margin: 0,
      width: "100%",
      overflow: "visible",
    },
    success: {
      visibility: "hidden",
      backgroundColor: "transparent",
      border: "none",
      borderTop: "none",
      boxShadow: "none",
      WebkitBoxShadow: "none",
      MozBoxShadow: "none",
      padding: 0,
      margin: 0,
      color: "transparent",
    },
  },
  MessageWrapper: {
    DefaultStyle: {
      display: "none",
    },
  },
  Title: {
    DefaultStyle: {
      display: "none",
    },
  },
  ActionWrapper: {
    DefaultStyle: {
      display: "none",
      margin: 0,
      padding: 0,
    },
  },
} satisfies NotificationSystem.Style;
